import React, { useState } from 'react';
import './Footer.css';

const email = 'h.selwayclarke@ucl.ac.uk';
const obfuscatedEmail = email.replace(/\./g, ' dot ').replace('@', ' at ');
const fixEmail = (email: string): string => {
    return email.replace(/\s+dot\s+/g, '.').replace(/\s+at\s+/, '@');
};

const Footer: React.FC = () => {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(fixEmail(obfuscatedEmail));
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <footer className="footer">
            <nav>
                <a href="https://bsky.app/profile/hughselwayclarke.bsky.social" target="_blank" rel="noopener noreferrer">
                    <img src="/assets/svgs/bluesky.svg" alt="Bluesky" />
                    <div> @hughselwayclarke.bsky.social </div>
                </a>
                <a href="https://x.com/HughSelway" target="_blank" rel="noopener noreferrer">
                    <img src="/assets/svgs/twitter.svg" alt="Twitter" />
                    <div> @HughSelway </div>
                </a>
                <button onClick={handleCopy} className={`copy-email ${copied ? 'copied' : ''}`}>
                    <img src="/assets/svgs/email.svg" alt="Email" />
                    <div> {obfuscatedEmail} </div>
                    <span className="copy-icon-container">
                        {copied ? <img src="/assets/svgs/tick.svg" alt="Copy" /> : <img src="/assets/svgs/copy.svg" alt="Copy" />}
                    </span>
                </button>
            </nav>
            <span>© {new Date().getFullYear()} Hugh Selway-Clarke</span>
        </footer>
    );
};

export default Footer; 